// Colored circle with a team's initials, using the team's own color. Shared by
// the AI team filter dropdown and the explorer table so they stay in sync.

// Initials from the team name. We don't use the DB `initials` column because
// it's unreliable (e.g. "K-" for "Ken - SaaS Validation"). First letters of the
// first two words, or the first two letters for a single word.
export const teamInitials = (name: string): string => {
  const words = name.split(/[\s\-/]+/).filter(Boolean)
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase()
  }
  return name.replace(/[^a-zA-Z0-9]/g, '').slice(0, 2).toUpperCase()
}

interface Props {
  name: string
  color: string | null
  size?: 'sm' | 'xs'
}

const TeamAvatar: React.FC<Props> = ({ name, color, size = 'sm' }) => (
  <span
    className={`flex shrink-0 items-center justify-center rounded-full font-semibold text-white ${
      size === 'xs' ? 'h-4 w-4 text-[8px]' : 'h-5 w-5 text-[9px]'
    }`}
    style={{ backgroundColor: color || '#64748b' }}
  >
    {teamInitials(name)}
  </span>
)

export default TeamAvatar
